import Vue from "vue";
import Dialog from "./dialog.vue";

// 将组件改成函数形式调用

const DialogBox = Vue.extend(Dialog);

DialogBox.install = function (options = {}) {
    //实例化组件
    let instance = new DialogBox().$mount();
    document.body.appendChild(instance.$el);
    console.log(instance);
    Vue.nextTick(() => {
        //添加默认函数
        instance.hideDialog = function () {
            instance.show = false;
        };

        //给实例的props赋值
        if (options.content) {
            instance.content = options.content;
            instance.show = true;
        }
        if (options.leftBtnText) instance.leftBtnText = options.leftBtnText;
        if (options.rightBtnText) instance.rightBtnText = options.rightBtnText;

        //添加相关函数
        instance.handleLeftBtn = function () {
            instance.show = false;
            if (Object.prototype.toString.call(options.leftBtnClick) === "[object Function]") {
                options.leftBtnClick();
            }
        };
        instance.handleConfirm = function () {
            instance.show = false;
            if (Object.prototype.toString.call(options.rightBtnClick) === "[object Function]") {
                options.rightBtnClick();
            }
        };
    });
};

export default DialogBox.install;
